var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('b-row',[_c('b-col',{staticClass:"col-xxl-8",attrs:{"lg":"6","xl":"6"}},[_vm._t("body")],2),_c('b-col',[_vm._t("sidebar")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }